import type { Command } from "../types.ts";
import { help } from "./help.ts";
import { about } from "./about.ts";
import { skills } from "./skills.ts";
import { projects } from "./projects.ts";
import { blog } from "./blog.ts";
import { social } from "./social.ts";
import { theme } from "./theme.ts";
import { clear, banner, echo, whoami, date } from "./misc.ts";

/**
 * The full command list, in the order they appear in /help.
 * Add a new command: create a file in this folder exporting a `Command`,
 * import it here, and drop it into the array.
 */
export const commands: Command[] = [
  help,
  about,
  skills,
  projects,
  blog,
  theme,
  social,
  banner,
  echo,
  whoami,
  date,
  clear,
];
